import { render, staticRenderFns } from "./CarManageAdd.vue?vue&type=template&id=147eb2c4&scoped=true"
import script from "./CarManageAdd.vue?vue&type=script&lang=js"
export * from "./CarManageAdd.vue?vue&type=script&lang=js"
import style0 from "./CarManageAdd.vue?vue&type=style&index=0&id=147eb2c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147eb2c4",
  null
  
)

export default component.exports